import _defineProperty from '@babel/runtime/helpers/defineProperty';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * A manager for adding/removing entries (from the resize observer) containing the dimensions of
 * observed DOM elements. Each entry is also enriched with data needed when submitting the data to
 * CET.
 * @return {Object} - Containing methods for adding (`addEntry`) and clearing (`clearEntries`)
 * entries as well as the entries themselves (`entries`).
 */
var createEntries = function createEntries() {
  var entries = new Map();
  /**
   * Will store each observed node reference as a key, with the value being an object of associated
   * props to include in each analytic request. Retrieving values from DOM attributes only need to
   * happen once and can be saved here.
   */

  var entry_context = new Map();
  /**
   * @param  {HTMLElement} id - The DOM node reference the entry pertains to.
   * @param  {Object} data - Additional data to store for an entry. This would include, at a
   * minimum, `width` and `height`.\
   */

  var addEntry = function addEntry(id, data) {
    entries.set(id, _objectSpread(_objectSpread(_objectSpread({}, entry_context.get(id) || {}), data), {}, {
      platform: window.matchMedia('screen and (max-width:51.9rem)').matches ? 'mobile' : 'desktop',
      ready_state: document.readyState,
      type: 'cls_event',
      user_agent: navigator.userAgent,
      viewport_size: {
        width: Number(window.screen.width),
        height: Number(window.screen.height)
      }
    }));
  };

  var addEntryContext = function addEntryContext(id, context) {
    entry_context.set(id, context);
  };

  var clearEntries = function clearEntries() {
    entries.clear();
    entry_context.clear();
  };

  return {
    addEntry: addEntry,
    addEntryContext: addEntryContext,
    clearEntries: clearEntries,
    entries: entries
  };
};

export { createEntries };
